import gnavToggle from './module/gnavToggle';
import addCurrentClass from './module/addCurrentClass';
import pcAddIshover from './module/pcAddIshover';

import introAnime from './module/introAnime';
import smoothscroll from './module/jquery.smoothscroll';
import accordion from './module/jquery.accordion';
import customCursor from './module/jquery.customCursor';
import pageLoadedEffect from './module/jquery.pageLoadedEffect';
import seeMore from './module/jquery.seeMore.js';
import scroll2AddClass from './module/jquery.scroll2AddClass.js';
import modal from './module/jquery.modal.js';
import pageMove from './module/pageMove.js';
import iconSizeCtl from './module/jquery.iconSizeCtl.js';
import matchGridR from './module/jquery.matchGridR.js';
import checkBg from './module/jquery.checkBg.js';

(function ($) {
  $(document).ready(function () {
    function matchHeight() {
      $('.js-match-height').css('height', $(window).height() + 'px');
    }

    // 未訪問・訪問済みセッションストレージをチェック
    window.is_visited = false;
    const firstView = sessionStorage.getItem('firstView');
    if (firstView == 1) window.is_visited = true;

    if(location.href.match('localhost')) {
      $('.c-grid').addClass('c-grid--local');
    }

    var userAgent = window.navigator.userAgent.toLowerCase();
    if(userAgent.indexOf('msie') != -1) {
      $('body').addClass('msie');
    }
    if(userAgent.indexOf('firefox') != -1) {
      $('body').addClass('ffx');
    }
    matchHeight();
    introAnime();
    gnavToggle();
    addCurrentClass();
    pcAddIshover();
    accordion();
    smoothscroll();
    customCursor();
    seeMore();
    modal();
    iconSizeCtl();
    checkBg();
    $(window).on('resize', matchHeight);
    $(window).on('resize', matchGridR);
    $(window).trigger('resize');

    // if($('.js-cb-css').length > 0) {
    //   console.log("ok");
    //   BackgroundCheck.init({
    //     targets: '.js-cb-target',
    //     images: '.js-cb-css'
    //   });
    // } else {
    //   BackgroundCheck.init({
    //     targets: '.js-cb-target'
    //   });
    // }

    if (!$('body').hasClass('home') &&
    !$('body').hasClass('page-form')) pageMove();


    Cookies.remove('tlVisited', { path: '/' });
    window.addEventListener("blur", () => {
      Cookies.remove('tlVisited', { path: '/' }); // PHPでセッションストレージの状態を確認
    });
    if (firstView == 1) {
      Cookies.set('tlVisited', 'visited', { path: '/' });
    }
    $('a[blank]').on('click', function() {
      Cookies.remove('tlVisited', { path: '/' });
    })
  });

  $(window).on('load', function () {
    // pageLoadedEffect();
    scroll2AddClass();
    sessionStorage.setItem('firstView', 1); // <- 訪問確認セッションストレージの保存
    Cookies.set('tlVisited', 'visited', { path: '/' });
  });
  $(window).on('scroll', function () {
    if($(window).scrollTop() > 10) {
      $('.l-header').addClass('is-scrolled');
    } else {
      $('.l-header').removeClass('is-scrolled');
    }
  });

})(jQuery);
window.onbeforeunload = function() {
};
window.onunload = function() {
};
